import { ServerConfig } from "@/config/config";
import { Axios } from "@/utils/axios";

export interface IYukiAdministration {
	ID: string;
	Name: string;
}

export class YukiServiceClass {
	private readonly baseUrl:string = `${ServerConfig.auth}/auth/yuki`;

	async getAdministrations(apiKey:string, domain:"be" | "nl"):Promise<IYukiAdministration[]>{
		let result = await Axios.post(`${this.baseUrl}/administrations`, {
			ApiKey: apiKey,
			Domain: domain
		});
		return result.data || [];
	}
}

export const YukiService = new YukiServiceClass();
